import { render, staticRenderFns } from "./SportOrganizationBuyerForm.vue?vue&type=template&id=90ed24d4&scoped=true"
import script from "./SportOrganizationBuyerForm.vue?vue&type=script&lang=js"
export * from "./SportOrganizationBuyerForm.vue?vue&type=script&lang=js"
import style0 from "./SportOrganizationBuyerForm.vue?vue&type=style&index=0&id=90ed24d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90ed24d4",
  null
  
)

export default component.exports